module.exports = __webpack_public_path__ + "static/img/production2.ad623b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/production2.png
// module id = Hwpb
// module chunks = 2